import SectionLabel from "@/components/base/SectionLabel";
import { businessToolData } from "@/mocks/businessToolData";

export default function BuildOrUseSection() {
  return (
    <section className="py-16 md:py-22 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16 reveal">
          <SectionLabel
            label={businessToolData.buildOrUse.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 md:mb-6">
            {businessToolData.buildOrUse.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            {businessToolData.buildOrUse.description}
          </p>
        </div>

        <div className="reveal grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-7">
            <div className="flex items-center gap-3 mb-4 md:mb-5 pb-4 border-b border-background-200/70">
              <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className={`${businessToolData.buildOrUse.existingTools.icon} text-secondary-600 text-lg`} />
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading">
                {businessToolData.buildOrUse.existingTools.title}
              </h3>
            </div>
            <ul className="space-y-2.5">
              {businessToolData.buildOrUse.existingTools.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-foreground-700">
                  <i className="ri-cloud-line text-secondary-500 mt-0.5 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg bg-primary-50/60 border border-primary-200/60 p-6 md:p-7">
            <div className="flex items-center gap-3 mb-4 md:mb-5 pb-4 border-b border-primary-200/60">
              <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                <i className={`${businessToolData.buildOrUse.customDev.icon} text-background-50 text-lg`} />
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading">
                {businessToolData.buildOrUse.customDev.title}
              </h3>
            </div>
            <ul className="space-y-2.5">
              {businessToolData.buildOrUse.customDev.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-foreground-700">
                  <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="max-w-2xl mx-auto mt-10 md:mt-12 reveal">
          <div className="text-center bg-primary-50/70 border border-primary-200/50 rounded-lg p-6 md:p-7">
            <p className="text-sm md:text-base font-bold text-primary-700 leading-relaxed">
              {businessToolData.buildOrUse.bottomText}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}